module.exports = __webpack_public_path__ + "img/Wahid.6d0a9eda.jpg";